import { useNavigate } from 'react-router-dom'
import { Screen } from '@/components/Screen'
import { Kicker } from '@/components/Kicker'
import { PACK_COLORS } from '@/design-system/tokens'
import {
  BottleIcon,
  DiaperIcon,
  SleepIcon,
  MedicationIcon,
  NoteIcon,
  HandoffIcon,
  HealthIcon,
} from '@/design-system/icons'

interface LogTile {
  id: string
  label: string
  color: string
  icon: React.ReactNode
  to: string
}

export function LogScreen() {
  const nav = useNavigate()

  const early = PACK_COLORS.early_care.light
  const health = PACK_COLORS.health.light
  const needs = PACK_COLORS.needs.light
  const school = PACK_COLORS.school.light

  const tiles: LogTile[] = [
    { id: 'feed', label: 'Feed', color: early, icon: <BottleIcon size={22} />, to: '/log/feed' },
    { id: 'diaper', label: 'Diaper', color: early, icon: <DiaperIcon size={22} />, to: '/log/diaper' },
    { id: 'sleep', label: 'Sleep', color: early, icon: <SleepIcon size={22} />, to: '/log/sleep' },
    { id: 'medication', label: 'Medication', color: health, icon: <MedicationIcon size={22} />, to: '/log/medication' },
    { id: 'growth', label: 'Growth', color: health, icon: <HealthIcon size={22} />, to: '/log/growth' },
    { id: 'note', label: 'Note', color: needs, icon: <NoteIcon size={22} />, to: '/log/note' },
    { id: 'handoff', label: 'Handoff', color: school, icon: <HandoffIcon size={22} />, to: '/handoff' },
  ]

  return (
    <Screen title="Log">
      <div className="px-4 pt-1 pb-6">
        <Kicker>What are you logging?</Kicker>
        <div className="mt-2 grid grid-cols-2 gap-2">
          {tiles.map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => nav(t.to)}
              className="flex flex-col items-start gap-2 p-4 rounded-r-sm bg-bg-elevated border border-divider-subtle active:scale-[0.98] transition-transform min-h-[96px]"
            >
              <div
                className="h-10 w-10 rounded-full flex items-center justify-center"
                style={{ background: t.color + '22', color: t.color }}
              >
                {t.icon}
              </div>
              <div className="text-body font-medium text-text-primary">{t.label}</div>
            </button>
          ))}
        </div>
      </div>
    </Screen>
  )
}
